import { render } from "./AlertBanner.vue?vue&type=template&id=4af16b0a&scoped=true"
import script from "./AlertBanner.vue?vue&type=script&lang=js"
export * from "./AlertBanner.vue?vue&type=script&lang=js"

import "./AlertBanner.vue?vue&type=style&index=0&id=4af16b0a&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af16b0a"]])

export default __exports__